<template>
	<div class="sp-template">
		<div class="h-title">报关行&清关行</div>
		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<el-form :inline="true" :model="conditions" class="demo-form-inline" size="small">
					<el-form-item label="名称">
						<el-input v-model="conditions.customsName" placeholder="请输入报关行或清关行名称" clearable></el-input>
					</el-form-item>
					<el-form-item>
						<el-button  v-if="in_configs(70604)" type="primary" @click="customsSearch">搜索</el-button>
					</el-form-item>
				</el-form>
			</div>
       <div class="table-operate__buttons">
        <el-tabs v-model="conditions.customsType" @tab-click="customsSearch">
          <el-tab-pane label="报关行" name="CUSTOMS_BROKER"></el-tab-pane>
          <el-tab-pane label="清关行" name="BROKER"></el-tab-pane>
        </el-tabs>
        <div class="button-groups">
          <el-button v-if="in_configs(70601)" size="small"  @click="addCustoms">添加</el-button>
        </div>
       </div>
			<el-table ref="multipleTable" v-loading="loading" :data="customsData" stripe border style="width: 100%">
				<el-table-column prop="customsType" label="类型" :formatter="formatType"></el-table-column>
				<el-table-column prop="customsName" label="名称"></el-table-column>
				<el-table-column prop="contacts" label="联系人"></el-table-column>
				<el-table-column prop="phone" label="电话" :formatter="formatPhone"></el-table-column>
				<el-table-column prop="customsAddress" label="地址"></el-table-column>
				<el-table-column prop="status" label="状态" :formatter="formatStatus"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button size="mini" type="text" v-if="in_configs(70602)" @click="customsEdit(scope.$index, scope.row)">编辑</el-button>
						<el-button size="mini" type="text" v-if="in_configs(70603)" @click="customsDelete(scope.$index, scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<el-pagination background @size-change="customsSizeChange" @current-change="customsCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
			<!-- 弹窗 -->
			<el-dialog title="报关行&清关行详情" :visible.sync="dialogFormVisible" :before-close="emptyForm" @close="rulesForm('customsForm')" width="500px" class="fullwidth-form__dialog">
				<el-form :model="customsForm" status-icon :rules="rules" ref="customsForm" size="small" label-width="80px">
					<el-form-item label="类型"  prop="customsType">
						<el-select v-model="customsForm.customsType" placeholder="请选择海关类型">
							<el-option v-for="item in customsTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="名称"  prop="customsName">
						<el-input v-model="customsForm.customsName" auto-complete="off" placeholder="名称"></el-input>
					</el-form-item>
					<el-form-item label="联系人"  prop="contacts">
						<el-input v-model="customsForm.contacts" auto-complete="off" placeholder="联系人"></el-input>
					</el-form-item>
					<el-form-item label="电话"  prop="phone">
						<el-input v-model="customsForm.phone" auto-complete="off" placeholder="电话"></el-input>
					</el-form-item>
					<el-form-item label="地址"  prop="customsAddress">
						<el-input v-model="customsForm.customsAddress" auto-complete="off" placeholder="地址"></el-input>
					</el-form-item>
					<el-form-item label="状态" >
						<el-radio v-model="customsForm.status" label="1">启用</el-radio>
						<el-radio v-model="customsForm.status" label="0">停用</el-radio>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button size="small" @click="close('customsForm')">取 消</el-button>
					<el-button size="small" type="primary" @click="submitCustomsForm('customsForm')">确 定</el-button>
				</div>
			</el-dialog>
		</el-card>
	</div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    //验证海关名称
    var validateCustomsName = (rule, value, callback) => {
      if (this.flag) {
        if (value == this.customsData.customsName) {
          callback();
          return;
        }
      }
      this.$request1({
        method: 'POST',
        url: '/customs/check',
        params: { customsName: this.customsForm.customsName }
      })
        .then(response => {
          if (response.data.message == "exist") {
            callback(new Error("名称已存在"));
          } else {
            callback();
          }
        })
        .catch(error => {
          console.log(error);
        });
    };
    //验证联系电话
    var validatePhone = (rule, value, callback) => {
      if (this.flag) {
        if (value == this.customsData.phone) {
          callback();
          return;
        }
      }
      this.$request1({
        method: 'POST',
        url: '/customs/check',
        params: { phone: this.customsForm.phone }
      })
        .then(response => {
          if (response.data.message == "exist") {
            callback(new Error("联系电话已存在"));
          } else {
            callback();
          }
        })
        .catch(error => {
          console.log(error);
        });
    };
    return {
      conditions: {
        customsType: "CUSTOMS_BROKER",
        customsName: ""
      },
      customsData: [],
      customsTypes: [
        { label: "清关行", value: "BROKER" },
        { label: "报关行", value: "CUSTOMS_BROKER" }
      ],
      customsForm: {
        id: "",
        customsType: "",
        customsName: "",
        contacts: "",
        phone: "",
        customsAddress: "",
        status: "1"
      },
      rules: {
        customsType: [
          { required: true, message: "请选择海关类型", trigger: "change" }
        ],
        customsName: [
          { required: true, message: "请输入名称", trigger: "blur" },
          { validator: validateCustomsName, trigger: "blur" }
        ],
        contacts: [
          { required: true, message: "请输入联系人", trigger: "blur" }
        ],
        phone: [
          { required: true, message: "请输入电话", trigger: "blur" }
          // { validator: validatePhone, trigger: "blur" },
          // {
          //   pattern: /^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\d{8}$|^0\d{2,3}-?\d{6,8}$/,
          //   message: "请输入正确的电话格式",
          //   trigger: "blur"
          // }
        ],
        customsAddress: [
          { required: true, message: "请输入地址", trigger: "blur" }
        ]
      },
      currentPage: 1, //当前页
      total: 1, //总条数
      pageSize: 10, //当前显示条数
      pageSizes: [10, 20, 50, 100], //显示条数
      dialogFormVisible: false,
      flag: false,
      loading: true,
      status: 0,
      formLabelWidth: "120px"
    };
  },
  components: {},
  created() {
    setTimeout(() => {
      this.loadCustoms("", "", this.currentPage, this.pageSize);
      this.loading = false;
    }, 900);
  },
  computed: {},
  methods: {
    //加载数据
    loadCustoms(customsType, customsName, currentPage, pageSize) {
      this.$request1({
        method: 'GET',
        url: '/customs/load',
        params: {
          customsType: customsType,
          customsName: customsName,
          currentPage: currentPage,
          pageSize: pageSize
        }
      })
        .then(response => {
          this.customsData = response.data.data;
          this.total = response.data.total;
        })
        .catch(error => {
          console.log(error);
        });
    },
    formatType(data) {
      switch (data.customsType) {
        case "BROKER":
          return "清关行";
          break;
        case "CUSTOMS_BROKER":
          return "报关行";
          break;
      }
    },
    formatPhone: function(row, column, phone) {
      return phone.substring(0, 7) + "****";
    },
    //转换状态显示：1：启用 0：停用
    formatStatus(data) {
      return data.status == "1" ? "启用" : "停用";
    },
    //搜索
    customsSearch() {
      this.loadCustoms(
        this.conditions.customsType,
        this.conditions.customsName,
        this.currentPage,
        this.pageSize
      );
    },
    //编辑
    customsEdit(index, row) {
      console.log(index, row);
      this.dialogFormVisible = true;
      this.flag = true;
      this.customsForm.id = row.customsId;
      this.customsForm.customsType = row.customsType;
      this.customsForm.customsName = row.customsName;
      this.customsData.customsName = row.customsName;
      this.customsForm.contacts = row.contacts;
      this.customsForm.phone = row.phone;
      this.customsData.phone = row.phone;
      this.customsForm.customsAddress = row.customsAddress;
      this.customsForm.status = row.status.toString();
      this.status = 1;
    },
    addCustoms() {
      this.dialogFormVisible = true;
      this.flag = false;
      this.status = 0;
    },
    //添加/修改海关
    submitCustomsForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$request1({
            method: 'post',
            url: '/customs/save',
            data: this.customsForm
          })
            .then(response => {
              this.dialogFormVisible = false;
              this.$refs[formName].resetFields();
              this.emptyForm();
              this.loadCustoms("", "", this.currentPage, this.pageSize);
              this.success();
            })
            .catch(error => {
              this.$message.error("操作失败");
            });
          this.dialogFormVisible = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //删除
    customsDelete(index, row) {
      console.log(index, row);
      let self = this;
      this.$confirm("此操作将永久删除该海关, 是否继续?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(_ => {
          this.$request1({
            method: 'post',
            url: '/customs/delete',
            params: {
              customsId: row.customsId
            }
          })
            .then(response => {
              self.customsData.splice(index, 1);
              this.$message({
                message: "删除成功",
                type: "success",
                center: true,
                duration: 1500
              });
            })
            .catch(error => {
              console.log(error);
              this.$message.error("操作失败");
            });
        })
        .catch(_ => {});
    },
    //清空表单数据
    emptyForm() {
      this.dialogFormVisible = false;
      this.customsForm.id = "";
      this.customsForm.customsType = "";
      this.customsForm.customsName = "";
      this.customsForm.contacts = "";
      this.customsForm.phone = "";
      this.customsForm.customsAddress = "";
      this.customsForm.status = "1";
    },
    //清除验证
    close(formRule) {
      this.$refs[formRule].clearValidate();
      this.emptyForm();
    },
    rulesForm(formRule) {
      this.$refs[formRule].clearValidate();
    },
    //操作成功
    success() {
      if (this.status == 1) {
        this.$message({
          message: "修改成功",
          type: "success",
          center: true,
          duration: 1500
        });
      } else {
        this.$message({
          message: "添加成功",
          type: "success",
          center: true,
          duration: 1500
        });
      }
    },
    //分页
    customsSizeChange(pageSizes) {
      this.pageSize = pageSizes;
      this.loadCustoms(
        this.conditions.customsType,
        this.conditions.customsName,
        this.currentPage,
        pageSizes
      );
    },
    customsCurrentChange(currentPage) {
      this.loadCustoms(
        this.conditions.customsType,
        this.conditions.customsName,
        currentPage,
        this.pageSize
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.box-card {
  margin: 20px -10px;
}
</style>


// WEBPACK FOOTER //
// src/views/system/customsclearance.vue